import { getConfigDataServer } from '../../../config'
import {
  setRolesData,
  setRolesProcessing,
  setRolesError,
  GET_ROLES_DATA,
} from './actions'
import {
  getUserRoles,
} from '..'

const log = console

async function getRolesDataHandler ({ store }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setRolesProcessing())
    if (auth.get('processing') !== false) {
      return
    }

    const data = await getUserRoles({
      auth,
      server: getConfigDataServer(config, 'auth'),
    })

    store.dispatch(setRolesData({
      data,
    }))
  } catch (error) {
    log.error(error, 'Error getting user roles.')
    store.dispatch(setRolesError({
      error,
    }))
  }
}

export default (store) => (next) => (action) => {
  const { type } = action
  switch (type) {
    case GET_ROLES_DATA:
      getRolesDataHandler({ store, action })
      break
    default:
      break
  }
  next(action)
}
